"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = void 0;
const Dashboard_1 = __importDefault(require("@mui/icons-material/Dashboard"));
const material_1 = require("@mui/material");
const tsGoThemeVars_1 = require("../../tsGoThemeVars");
exports.StyledIcon = (0, material_1.styled)(Dashboard_1.default)(() => ({
    '&.expanded, &.collapsed': {
        color: tsGoThemeVars_1.goPalette.tsGoColor.grayDark,
        position: 'relative',
    },
    '&:hover, &.active-icon': {
        color: tsGoThemeVars_1.goPalette.tsGoColor.white,
    },
}));
